<template>
  <div id="app">
    <div class="page">
      <header class="header">
        <div class="grid-container">
          <div class="grid-x grid-padding-x">
            <div class="small-12 cell text-center">
              <a href="./">
                <img
                  src="./assets/logo.svg"
                  class="logo"
                  width="350"
                  height="64"
                  alt="Fidelidade Auto Easy"
                />
              </a>
            </div>
          </div>
        </div>
      </header>

      <main id="main">
        <section class="heroshot position-relative" id="form">
          <div class="img-dog">
            <img src="./assets/dog.svg" width="220" height="280" alt="logo" />
            <div class="img-dog__text">
              SEGURO <br />
              ACIDENTES <br />
              DE TRABALHO
            </div>
          </div>
          <div class="grid-container no-padding">
            <div class="full-height">
              <div class="small-12 cell full-height position-relative">
                <img
                  src="./assets/img-hero-mobile@2x.jpg"
                  class="show-for-small-only"
                />
                <div class="heroshot__wrapper">
                  <div class="heroshot__content">
                    <h1 class="heroshot__title">TRABALHADORES DOMÉSTICOS</h1>
                    <h2 class="heroshot__subtitle">
                      ESTAMOS SEGUROS E QUEM CUIDA DA NOSSA FAMÍLIA TAMBÉM.
                    </h2>
                    <p class="heroshot__text">Simule e contrate já o Seguro.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="lead">
            <lead-store-component
              :open-form.sync="openForm"
            ></lead-store-component>
          </div>
        </section>

        <div class="lead-mobile">
          <lead-store-component
            :open-form.sync="openForm"
          ></lead-store-component>
        </div>

        <section class="intro">
          <div class="grid-container">
            <div class="grid-x grid-padding-x align-center">
              <div class="small-12 medium-10 large-8 cell text-center">
                <h2 class="intro__title intro__title--primary">
                  FAÇA JÁ A SIMULAÇÃO E CONTRATE O SEGURO PARA O SEU TRABALHADOR
                  DOMÉSTICO.
                </h2>
                <h3 class="intro__title">ADESÃO TOTALMENTE ONLINE.</h3>
                <p class="intro__text">
                  A Fidelidade criou um simulador que lhe permite saber o valor
                  do Seguro de Acidentes de Trabalho para os seus Trabalhadores
                  Domésticos e avançar para a contratação de imediato.
                </p>
                <a
                  href="https://www.fidelidade.co.ao/ao/particulares/auto/simular/at/Paginas/default.aspx"
                  id="btn-simule-a"
                  class="btn btn--cta"
                  target="_blank"
                >
                  Simule já
                </a>
              </div>
            </div>
          </div>

          <div class="grid-container">
            <div class="grid-x grid-padding-x align-center">
              <div class="small-11 large-10 cell text-center">
                <div class="boxes">
                  <vue-slick-carousel v-bind="settings">
                    <div class="box">
                      <img src="./assets/icon-ppl.svg" />
                      <h3 class="box__title">
                        PROTECÇÃO NUM<br />ÚNICO SEGURO
                      </h3>
                    </div>
                    <div class="box">
                      <img src="./assets/icon-money.svg" />
                      <h3 class="box__title">FACILIDADE<br />DE PAGAMENTO</h3>
                    </div>
                    <div class="box">
                      <img src="./assets/icon-shield_v2.svg" />
                      <h3 class="box__title">SEGURANÇA<br />E CONFORTO</h3>
                    </div>
                    <div class="box">
                      <img src="./assets/icon-heart_v2.svg" />
                      <h3 class="box__title">ASSISTÊNCIA<br />MÉDICA</h3>
                    </div>
                  </vue-slick-carousel>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section class="cta">
          <div class="grid-container">
            <div class="grid-x grid-padding-x align-center">
              <div class="small-11 medium-10 large-9 cell text-center">
                <p>
                  COM O SEGURO TRABALHADORES DOMÉSTICOS, GARANTA MAIOR PROTECÇÃO
                  NAS ROTINAS DE TRABALHO DOS SEUS FUNCIONÁRIOS.
                </p>
              </div>
            </div>
          </div>
        </section>

        <section class="info">
          <div class="grid-container info__row">
            <div class="grid-x grid-padding-x align-center align-middle">
              <div
                class="
                  small-12
                  medium-10
                  large-5
                  cell
                  text-center
                  large-order-1
                "
              >
                <img
                  src="./assets/img-intro1.jpg"
                  srcset="./assets/img-intro1@2x.jpg 2x"
                  class="info__img"
                  alt="Totalmente online e facilidade de pagamento"
                />
              </div>
              <div class="small-11 medium-10 large-5 cell">
                <div class="info__item info__item--margin">
                  <div class="info__title">PROTECÇÃO NUM ÚNICO SEGURO</div>
                  <div class="info__text">
                    Este seguro destina-se a pessoas ou famílias que tenham
                    trabalhadores domésticos a tempo inteiro ou parcial. Os
                    trabalhadores assegurados* ficam protegidos nos termos
                    exigidos pela lei, tendo direito a prestações de natureza
                    <strong>
                      médica, cirúrgica, farmacêutica, hospitalar,
                    </strong>
                    entre outras**.
                  </div>
                </div>
                <div class="info__item">
                  <div class="info__title">FACILIDADE DE PAGAMENTO</div>
                  <div class="info__text">
                    <strong>
                      O empregador pode escolher a duração do seguro do seu
                      trabalhador doméstico (tempo inteiro ou parcial) e optar
                      por uma das soluções de pagamento (trimestral, semestral
                      ou anual).
                    </strong>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="grid-container info__row">
            <div class="grid-x grid-padding-x align-center align-middle">
              <div
                class="
                  small-12
                  medium-10
                  large-5
                  cell
                  text-center
                  larger-order-1
                "
              >
                <img
                  src="./assets/img-intro2.jpg"
                  srcset="./assets/img-intro2@2x.jpg 2x"
                  class="info__img"
                  alt="Totalmente online e facilidade de pagamento"
                />
              </div>
              <div class="small-11 medium-10 large-5 cell">
                <div class="info__item info__item--margin">
                  <div class="info__title">PARTICIPAÇÃO RÁPIDA</div>
                  <div class="info__text">
                    Os sinistros podem ser participados de forma
                    <strong>fácil</strong> e <strong>rápida</strong>, através do
                    e-mail: acidente.trabalho@fidelidade.co.ao ou da linha SOS:
                    923 167 177.
                  </div>
                </div>
                <div class="info__item">
                  <div class="info__title">ASSISTÊNCIA MÉDICA</div>
                  <div class="info__text">
                    Acesso dos trabalhadores acidentados a um serviço de
                    <strong>assistência privada personalizada</strong> e de
                    <strong>qualidade</strong>, através de clínicas
                    reconhecidas.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="grid-container info__row">
            <div class="grid-x grid-padding-x align-center">
              <div class="small-12 medium-10 cell">
                <p class="warning">
                  *Cozinheira (o), Babá, Segurança, Jardineiro, Lavadeira,
                  Motorista, Cuidador de idoso, Governanta.
                  <br /><br />
                  **Desde que necessárias e adequadas ao restabelecimento do
                  estado de saúde e da capacidade de trabalho ou de ganho e à
                  recuperação para a vida activa.
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>

      <footer class="footer">
        <div class="footer__bottom">
          <div class="grid-container">
            <div class="grid-x grid-padding-x">
              <div class="small-12 medium-6 cell">
                <div class="logo-link">
                  <a
                    href="https://www.fidelidade.co.ao/ao/particulares/Paginas/default.aspx"
                    target="_blank"
                    class="site-link"
                    >fidelidade.co.ao</a
                  >
                  <ul class="socials">
                    <li class="socials__item">
                      <a
                        href="https://instagram.com/segurosfidelidadeangola"
                        target="_blank"
                        class="social__btn"
                      >
                        <img
                          src="./assets/icon-instagram.svg"
                          width="30"
                          height="30"
                          class="instagram_icon"
                        />
                      </a>
                    </li>
                    <li class="socials__item">
                      <a
                        href="https://www.facebook.com/FidelidadeSeguros.Angola/"
                        target="_blank"
                        class="social__btn"
                      >
                        <img
                          src="./assets/icon-facebook.svg"
                          width="30"
                          height="30"
                          class="facebook_icon"
                        />
                      </a>
                    </li>
                    <li class="socials__item">
                      <a
                        href="https://youtube.com/c/FidelidadeAngolaSeguros"
                        target="_blank"
                        class="social__btn"
                      >
                        <img
                          src="./assets/icon-youtube.svg"
                          width="30"
                          height="30"
                          class="youtube_icon"
                        />
                      </a>
                    </li>
                    <li class="socials__item">
                      <a
                        href="https://www.linkedin.com/company/segurosfidelidadeangola"
                        target="_blank"
                        class="social__btn"
                      >
                        <img
                          src="./assets/icon-linkedin.svg"
                          width="30"
                          height="30"
                          class="linkedin_icon"
                        />
                      </a>
                    </li>
                    <li class="socials__item">
                      <a
                        href="https://www.tiktok.com/@fidelidade.angola"
                        target="_blank"
                        class="social__btn"
                      >
                        <img
                          src="./assets/icon-tiktok.svg"
                          width="30"
                          height="30"
                          class="linkedin_icon"
                        />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="grid-container text-center">
            <div class="grid-x grid-padding-x">
              <div class="small-12 cell">
                <p class="footer__text">
                  Esta informação não dispensa a consulta da informação
                  pré-contrato e contratual legalmente exigida.<br /><br /><strong
                    >FIDELIDADE ANGOLA</strong
                  >
                  - Companhia de Seguros, S.A.<br />
                  Sede: Condomínio Cidade Financeira, Via S8, Edifício 10 - Piso
                  3, Talatona - Luanda - Angola. Matriculada na Conservatória do
                  Registo Comercial de Luanda sob o n.º 1.234-09 - NIF
                  5417061590. Capital Social: 3.034.080.000,00 AOA. Tel. +244
                  923 167 167 - atendimento@ﬁdelidade.co.ao
                </p>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <div class="fixed-bar">
        <div class="grid-container">
          <div class="grid-x grid-padding-x align-center">
            <div class="small-12 cell">
              <div class="grid-x grid-padding-x align-middle">
                <div class="small-12 cell">
                  <div
                    class="
                      flex-container
                      align-center
                      btn-container
                      text-center
                    "
                  >
                    <a
                      href="https://www.fidelidade.co.ao/ao/particulares/auto/simular/at/Paginas/default.aspx"
                      id="btn-simule-c"
                      class="btn btn--red"
                      target="_blank"
                      >SIMULE JÁ</a
                    >
                    <a href="#form" id="btn-simule-c" class="btn btn--red"
                      >QUERO SER CONTACTADO</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LeadStoreComponent from "./components/LeadStore/LeadStoreComponent.vue";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
// optional style for arrows & dots
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

function getParameterByName(name) {
  name = name.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
  var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
  var results = regex.exec(location.search);
  return results === null
    ? ""
    : decodeURIComponent(results[1].replace(/\+/g, " "));
}

export default {
  name: "App",
  components: {
    VueSlickCarousel,
    LeadStoreComponent,
  },
  data() {
    return {
      utm_campaign: null,
      utm_source: null,
      utm_medium: null,
      utm_content: null,
      utm_term: null,
      settings: {
        dots: true,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 4,
        focusOnSelect: true,
        touchThreshold: 5,
        responsive: [
          {
            breakpoint: 11600,
            settings: "unslick",
          },
          {
            breakpoint: 640,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      },
    };
  },
  methods: {
    generateURL() {
      var baseURL =
        "https://www.fidelidade.co.ao/ao/particulares/auto/auto/Paginas/autoeasy.aspx" +
        "?utm_campaign=" +
        this.utm_campaign;
      if (this.utm_source) {
        baseURL = baseURL + "&utm_source=" + this.utm_source;
      }
      if (this.utm_medium) {
        baseURL = baseURL + "&utm_medium=" + this.utm_medium;
      }
      if (this.utm_content) {
        baseURL = baseURL + "&utm_content=" + this.utm_content;
      }
      if (this.utm_term) {
        baseURL = baseURL + "&utm_term=" + this.utm_term;
      }
      return baseURL;
    },
  },
  created() {
    this.utm_campaign = getParameterByName("utm_campaign");
    this.utm_source = getParameterByName("utm_source");
    this.utm_medium = getParameterByName("utm_medium");
    this.utm_content = getParameterByName("utm_content");
    this.utm_term = getParameterByName("utm_term");
    if (this.utm_campaign) {
      this.link_one = this.generateURL();
    } else {
      this.link_one = this.initialUrl;
    }
  },
};
</script>

<style lang="scss">
@import "./styles/app.scss";
@import "./components/LeadStore/style/leadstore.scss";
</style>
